import styled from 'styled-components';

export const Flex1 = styled.div`
  flex: 1;
`;

export const ConvertMilage = styled(Flex1)`
  display: flex;
  flex-direction: column;
`;
export const ConvertMilageBoxLeftDes = styled.p`
  font-weight: 300;
  margin-bottom: ${({ theme }) => theme.spacing.x4};
  font-size: 12px;
  color: '#757575' !important;
`;
export const ConvertMilageBox = styled(Flex1)`
  display: flex;
  align-items: flex-start !important;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
    align-items: unset !important;
  }
`;
export const ConvertMilageBoxLeft = styled(Flex1)`
  margin-inline-end: ${({ theme }) => theme.spacing.x4};
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin-bottom: ${({ theme }) => theme.spacing.x8};
    margin-inline-end: 0;
  }
`;
export const ConvertMilageBoxLeftCard = styled(Flex1)`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x5}`};
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const ConvertMilageBoxLeftMember = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x4} ${theme.spacing.x6}`};
  display: flex;
  flex-direction: column;
`;

export const ConvertMilageBoxLeftText = styled.p`
  font-weight: 500;
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const ConvertMilageBoxLeftMemberDivider = styled.div`
  margin: ${({ theme }) => theme.spacing.x8} 0;
  display: flex;
  border: 1px solid #d8dbdf;
  position: relative;
`;

export const ConvertMilageBoxLeftMemberDividerSpan = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #d8dbdf;
  background: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => theme.spacing.x1};
`;

export const ConvertMilageBoxLeftBtn = styled(Flex1)`
  margin: auto auto 0;

  font-size: ${({ theme }) => theme.fs.xs};
`;

export const ConvertMilageBoxRight = styled(Flex1)`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    max-width: 100%;
  }
`;
